<template>
  <div class="page">
    <!-- <div class="page-header flex-between">
      <div class="page-header-left flex-center">
        <img src="@/assets/images/system/logo.png" alt="" class="logo" />
        <div class="nav-list flex-center">
          <div
            :class="['nav-item', route.path == item.path ? 'active' : '']"
            v-for="(item, index) in navList"
            :key="index"
            @click="router.push({ path: item.path })"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="page-header-right flex-center">
        <div class="nav-item">新用户体验</div>
        <div
          class="apply-use flex-center"
          @click="router.push({ path: '/apply' })"
        >
          申请使用
        </div>
      </div>
    </div>
    <div class="page-main clearfix">
      <div v-if="ossImgEditRole" class="edit-oss-img">
        <el-button type="primary" @click="ossImgRef.openDialog()"
          >编辑页面图片</el-button
        >
      </div>
      <ossImg v-if="ossImgEditRole" ref="ossImgRef"></ossImg> -->
      <router-view></router-view>
    <!-- </div>
    <div class="copyright flex-center" v-if="route.path != '/apply'">
      <span>北京国联政信科技有限公司版权所有 &nbsp;</span>
      <a class="icp" href="https://beian.miit.gov.cn/" target="_blank"
        >京ICP备19016313号-3</a
      >
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import ossImg from "@/components/ossImg/index.vue";

const route = useRoute();
const router = useRouter();

const ossImgEditRole = ref(localStorage.getItem("ossImgEdit-role"));

const ossImgRef = ref(null);

const navList = ref([
  {
    title: "首页",
    path: "/home",
  },
  {
    title: "智慧调解",
    path: "/mediate",
  },
  {
    title: "审辅服务",
    path: "/judge",
  },
  {
    title: "数字化市域治理",
    path: "/digitization",
  },
  {
    title: "生态与合作",
    path: "/ecology",
  },
]);
</script>
<style lang="less">
.page-conainer {
  > .banner {
    width: 100%;
    margin-top: 60px;
    > img {
      // height: 100%;
      width: 100%;
    }
  }
  > .oss-img {
    width: 100%;
  }
}
</style>
<style lang="less" scoped>
// .page-header {
//   position: fixed;
//   width: 100%;
//   height: 60px;
//   background-color: rgba(255, 255, 255, 0.9);
// }
// .page-header-left {
//   .logo {
//     height: 30px;
//     margin-left: 32px;
//     margin-right: 20px;
//   }
//   .nav-list {
//     color: #2d323d;
//     font-size: 14px;
//     .nav-item {
//       cursor: pointer;
//       & + .nav-item {
//         margin-left: 30px;
//       }
//       &:hover,
//       &.active {
//         color: #2a5dff;
//         font-weight: 600;
//       }
//     }
//   }
// }
// .page-header-right {
//   height: 100%;
//   .apply-use {
//     height: 100%;
//     background: #2a5dff;
//     width: 120px;
//     color: #ffffff;
//     margin-left: 20px;
//     cursor: pointer;
//   }
// }

// .page-main {
//   min-height: 100vh;
// }

// .copyright {
//   height: 50px;
//   font-size: 14px;
//   color: rgba(134, 144, 156, 1);
//   .icp {
//     text-decoration: none;
//     &:visited {
//       color: rgba(134, 144, 156, 1);
//     }
//   }
// }

// .edit-oss-img {
//   position: fixed;
//   top: 100px;
//   right: 100px;
//   z-index: 99;
// }
.page{
  width: 100%;
  height: 100%;
}
</style>
